import css from 'styled-jsx/css';

export const AdditionalPDPLabelStyles = css`
  /* Block: Main component */
  .additional-pdp-label {
    display: flex;
    align-items: center;
    gap: 12px;
    line-height: 1.4;
  }

  /* Elements: Icon container and icon */
  .additional-pdp-label__icon-container {
    flex-shrink: 0;
    display: flex;
    align-items: center;
  }

  .additional-pdp-label__icon {
    display: block;
    width: 20px;
    height: 20px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }

  /* Elements: Content container */
  .additional-pdp-label__content {
    flex: 1;
    color: #767676;
  }

  /* Elements: Text container for inline layout */
  .additional-pdp-label__text {
    display: inline;
    font-size: 12px;
    line-height: 1.4;
  }

  .additional-pdp-label__description {
    color: #767676;
    font-size: 12px;
    margin-right: 4px;
  }

  /* Elements: Link styling */
  .additional-pdp-label__link {
    color: #767676;
    text-decoration: underline;
    font-size: 12px;
    font-weight: normal;
    transition: color 0.2s ease;
    margin-left: 0;
  }

  .additional-pdp-label__link:hover {
    color: #000000;
    text-decoration: underline;
  }

  .additional-pdp-label__link:focus {
    outline-offset: 2px;
  }

  /* Responsive design */
  @media screen and (max-width: 1023px) {
    .additional-pdp-label {
      padding: 10px 12px;
      gap: 10px;
      margin-bottom: 12px;
    }

    .additional-pdp-label__icon {
      width: 18px;
      height: 18px;
    }

    .additional-pdp-label__text {
      font-size: 12px;
    }

    .additional-pdp-label__description {
      font-size: 12px;
    }

    .additional-pdp-label__link {
      font-size: 12px;
    }
  }

  /* Accessibility improvements */
  @media (prefers-reduced-motion: reduce) {
    .additional-pdp-label__link {
      transition: none;
    }
  }

  @media (prefers-contrast: high) {
    .additional-pdp-label__link {
      text-decoration-thickness: 2px;
    }
  }
`;
